import React from 'react';
import AdminMasterLayout from '../../../layouts/gcadmin/adminMasterLayout/AdminMasterLayout';
import AdminIssuedBooks from '../../../subsreens/gcadmin/adminissuedbooks/AdminIssuedBooks';



const AdminIssued = () => {
    return(
        <AdminMasterLayout>
            <AdminIssuedBooks></AdminIssuedBooks>
        </AdminMasterLayout>
    )
}

export default AdminIssued;